import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { BlockHeading } from 'components/Content/Atoms/BlockHeading';
import styles from './Video.module.scss';
import { getEmbedUrl } from './VideoHelpers';

interface Props {
  content: ContentType;
}
export function Video(props: Props) {
  const { content } = props;
  const { translate } = useGetContentTranslations();
  const url = translate(content.translations, 'url');
  const label = translate(content.translations, 'label');
  const secondaryText = translate(content.translations, 'description');
  const embedUrl = getEmbedUrl(url);
  return (
    <ContentContainer content={content}>
      <BlockHeading title={label} secondaryText={secondaryText} />
      <iframe title="Video Preview" src={embedUrl} allowFullScreen className={styles.videoIframe} />
    </ContentContainer>
  );
}
